import React, { useRef } from 'react';
import { Input } from 'antd';

interface SearchBarProps {
  onSearch: (value: string) => void;
  placeholder: string;
  width:any
}

const SearchBar: React.FC<SearchBarProps> = ({
  onSearch,
  placeholder,
  width
}) => {

  return (
    <Input.Search

      className="search-bar"
      size="small"
      placeholder={placeholder}
      allowClear
      onSearch={onSearch}
      style={{
        width: width,
        marginLeft: '13px',
      }}
  
    />
  );
};

export default SearchBar;
